export default __webpack_public_path__ + "static/media/sp.20f0274d.png";